//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "memberSearch",
  data() {
    return {
      loading: false,
      memberInputDto: {},
      list: [],
      columns: [
        {key: 'id', title: 'id', align: 'center', width: 100},
        {key: 'name', title: '姓名', align: 'center',},
        {key: 'phoneNumber', title: '手机号', align: 'center',},
        {
          key: 'cardType', title: '证件类型', align: 'center',
          render: (h, params) => {
            const row = params.row;
            let str = ''
            switch (row.cardType) {
              case 0:
                str = '居民身份证'
                break;
              case 1:
                str = '护照'
                break
              case 2:
                str = '军官证'
                break
              case 3:
                str = '营业执照'
                break
            }
            return h('span', str)
          }
        },
        {key: 'cardNum', title: '证件号', align: 'center',},
        {title: '关联房产', align: 'center', slot: 'room', minWidth: 500},
      ],
      roomColumns: [
        {key: 'id', title: 'id', align: 'center',},
        {key: 'projectName', title: '项目名称', align: 'center',},
        {key: 'roomNum', title: '房号', align: 'center',},
      ],
      rules: {
        name: [
          {required: true, message: 'The name cannot be empty', trigger: 'blur'}
        ],
        phoneNumber: [
          {required: true, message: 'The phoneNumber cannot be empty', trigger: 'blur'}
        ],
        cardType: [
          {required: true, type: 'number', message: 'The cardType cannot be empty', trigger: 'change'}
        ],
        cardNum: [
          {required: true, message: 'The cardNum cannot be empty', trigger: 'blur'}
        ],
      },
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
    }
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.onSearch();
    },
    pageSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.onSearch();
    },
    onSearch() {
      abp.ajax.post('/api/services/app/Member/QuerySimilarMembers', this.memberInputDto).then(res => {
        this.list = [];
        this.list.push(...res.data.result.items);
        this.totalCount = res.data.result.totalCount;
      });
    },

    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onSearch();
        }
      })
    },

  },
  created() {
    // this.onSearch();
  }
}
